import api from "./Api";

function getImage(id) {
  if (id) {
    return api.get("/images/" + id).then((response) => {
      if (response.data.success === true) {
        return response.data.data.location;
      }
    });
  }
}

export const Image = {
  getImage,
};

export default Image;
